import 'angular:ssr-entry-inject-manifest';
import * as server from './src/server';
export * from './src/server';
const defaultExportName = 'default';
export default server[defaultExportName]
export { AngularAppEngine } from '@angular/ssr';